import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import cn from 'classnames';
import { Trash } from '../../../icons';
import { IconButton } from '../../IconButton';
import { Typography } from '../../Typography';
import styles from '../EditableTableList.module.scss';
import { buttonBi, columnWidthClass, columnWidthStyle } from '../EditableTableList.utils';
import { SortableTableRow } from '../SortableTableRow';
export function EditableTableListDesktop(param) {
    let { rows, columns, disabledRowTooltip, onRemoveRow, renderRowFooter, belowEditableSlot, totalSummary, totalSummaryTestId, hideHeaderWhenEmpty, bi, testIds, dnd } = param;
    const { dragEnabled, rowIds, rowIsStatic, withDndContext, withSortableItems } = dnd;
    const footerColSpan = columns.length + (onRemoveRow != null ? 1 : 0) + (dragEnabled ? 1 : 0);
    const showHeader = !(hideHeaderWhenEmpty && rows.length === 0);
    const editableRowCount = rows.filter((row, rowIndex)=>!rowIsStatic(row, rowIndex)).length;
    const renderSlotRow = ()=>belowEditableSlot == null ? null : /*#__PURE__*/ _jsx(TableRow, {
            children: /*#__PURE__*/ _jsx(TableCell, {
                colSpan: footerColSpan,
                className: styles.belowEditableCell,
                children: belowEditableSlot
            })
        });
    const renderRowCells = (row, rowIndex)=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                columns.map((column)=>/*#__PURE__*/ _jsx(TableCell, {
                        align: column.align,
                        className: columnWidthClass(column),
                        style: columnWidthStyle(column),
                        "data-testid": testIds.Cell(rowIndex, column.key),
                        children: column.renderCell(row, rowIndex)
                    }, column.key)),
                onRemoveRow != null && /*#__PURE__*/ _jsx(TableCell, {
                    align: "right",
                    className: styles.removeCell,
                    children: rowIsStatic(row, rowIndex) ? disabledRowTooltip != null && /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, buttonBi(bi === null || bi === void 0 ? void 0 : bi.removeButton)), {
                        skin: "transparent",
                        size: "small",
                        noPadding: true,
                        disabled: true,
                        cursorDefault: true,
                        testId: testIds.RemoveButton(rowIndex),
                        tooltip: {
                            title: disabledRowTooltip,
                            placement: 'top',
                            enableOnMobile: true
                        },
                        children: /*#__PURE__*/ _jsx(Trash, {
                            size: 24
                        })
                    })) : /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread({}, buttonBi(bi === null || bi === void 0 ? void 0 : bi.removeButton)), {
                        skin: "transparent",
                        size: "small",
                        noPadding: true,
                        testId: testIds.RemoveButton(rowIndex),
                        onClick: ()=>onRemoveRow(rowIndex),
                        children: /*#__PURE__*/ _jsx(Trash, {
                            size: 24
                        })
                    }))
                })
            ]
        });
    return withDndContext(/*#__PURE__*/ _jsx(TableContainer, {
        className: styles.tableContainer,
        "data-testid": testIds.Root(),
        children: /*#__PURE__*/ _jsxs(Table, {
            children: [
                showHeader && /*#__PURE__*/ _jsx(TableHead, {
                    children: /*#__PURE__*/ _jsxs(TableRow, {
                        children: [
                            dragEnabled && /*#__PURE__*/ _jsx(TableCell, {
                                padding: "checkbox"
                            }),
                            columns.map((column)=>{
                                var _column_align;
                                return /*#__PURE__*/ _jsx(TableCell, {
                                    align: column.align,
                                    className: cn(columnWidthClass(column), {
                                        [styles.inputAlignedHeader]: column.alignHeaderToInput
                                    }),
                                    style: columnWidthStyle(column),
                                    "data-testid": testIds.Header(column.key),
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "paragraph3",
                                        weight: "light",
                                        align: (_column_align = column.align) !== null && _column_align !== void 0 ? _column_align : column.alignHeaderToInput ? undefined : 'center',
                                        children: column.header
                                    })
                                }, column.key);
                            }),
                            onRemoveRow != null && /*#__PURE__*/ _jsx(TableCell, {
                                className: styles.removeCell
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(TableBody, {
                    children: [
                        showHeader && /*#__PURE__*/ _jsx(TableRow, {
                            "aria-hidden": true,
                            children: /*#__PURE__*/ _jsx(TableCell, {
                                colSpan: footerColSpan,
                                className: styles.headerSpacer
                            })
                        }),
                        editableRowCount === 0 && renderSlotRow(),
                        withSortableItems(rows.map((row, rowIndex)=>{
                            const footerContent = renderRowFooter === null || renderRowFooter === void 0 ? void 0 : renderRowFooter(row, rowIndex);
                            const hasFooter = footerContent != null;
                            const isLastBeforeSlot = belowEditableSlot != null && rowIndex === editableRowCount - 1;
                            const rowClassName = cn(styles.tableRow, {
                                [styles.hasFooter]: hasFooter,
                                [styles.lastBeforeSlot]: isLastBeforeSlot && !hasFooter
                            });
                            return /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    dragEnabled && !rowIsStatic(row, rowIndex) ? /*#__PURE__*/ _jsx(SortableTableRow, {
                                        id: rowIds[rowIndex],
                                        rowTestId: testIds.Row(rowIndex),
                                        handleTestId: testIds.DragHandle(rowIndex),
                                        className: rowClassName,
                                        children: renderRowCells(row, rowIndex)
                                    }) : /*#__PURE__*/ _jsxs(TableRow, {
                                        className: rowClassName,
                                        "data-testid": testIds.Row(rowIndex),
                                        children: [
                                            dragEnabled && /*#__PURE__*/ _jsx(TableCell, {
                                                padding: "checkbox"
                                            }),
                                            renderRowCells(row, rowIndex)
                                        ]
                                    }),
                                    hasFooter && /*#__PURE__*/ _jsx(TableRow, {
                                        className: cn(styles.rowFooterRow, {
                                            [styles.lastBeforeSlot]: isLastBeforeSlot
                                        }),
                                        children: /*#__PURE__*/ _jsx(TableCell, {
                                            colSpan: footerColSpan,
                                            className: styles.footerCell,
                                            "data-testid": testIds.RowFooter(rowIndex),
                                            children: footerContent
                                        })
                                    }),
                                    isLastBeforeSlot && renderSlotRow()
                                ]
                            }, rowIds[rowIndex]);
                        })),
                        totalSummary != null && /*#__PURE__*/ _jsxs(TableRow, {
                            "data-testid": totalSummaryTestId,
                            className: styles.totalSummaryRow,
                            children: [
                                /*#__PURE__*/ _jsx(TableCell, {
                                    colSpan: (dragEnabled ? 1 : 0) + columns.length - 1,
                                    align: "right",
                                    children: totalSummary.label
                                }),
                                /*#__PURE__*/ _jsx(TableCell, {
                                    align: "right",
                                    className: columnWidthClass(columns[columns.length - 1]),
                                    style: columnWidthStyle(columns[columns.length - 1]),
                                    children: totalSummary.value
                                }),
                                onRemoveRow != null && /*#__PURE__*/ _jsx(TableCell, {
                                    className: styles.removeCell
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}
